import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiContentLanguageSharedService } from './fi-content-language-shared.service';

@NgModule({
    imports: [CommonModule],
    declarations: [],
    providers: [FiContentLanguageSharedService],
})
export class FiContentLanguageSharedModule {}
